import type { Rules } from "../types";
import { rulesV1 } from "./v1";
import { rulesV2 } from "./v2";

export const rulesRegistry: Record<string, Rules> = {
  "1": rulesV1,
  "2": rulesV2,
};

export const CURRENT_RULES_VERSION = "2";
export const currentRules = rulesV2;
// Character payloads written before rules versioning existed are Game 1 sheets.
export const LEGACY_RULES_VERSION = "1";

export function getRulesForVersion(version: string): Rules {
  return rulesRegistry[version] ?? rulesRegistry[LEGACY_RULES_VERSION]!;
}
